import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Box from "@mui/material/Box";
import TableContainer from "../../../components/Tables/TableContainer";
import {
  COLUMN_NAME_ACTIONS,
  COLUMN_NAME_EMAIL,
  COLUMN_NAME_NAME,
  COLUMN_NAME_ROLE,
  EMPTY_USERS,
  USERS_TABLE_ARIA_LABEL,
  ANONYMOUS_USER,
} from "../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";
import TableCell from "../../BillingAndPayments/components/TableCell";
import ActionsUser from "./ActionsUser";
import _ from "lodash";
import { ADVERTISER_ROLE, SUPER_ADMIN_ROLE } from "../../../utils/constants";

const UsersTable = ({
  data = {},
  loading,
  showEmail = true,
  showActions = true,
  showRole = true,
  filterByAdvertiserAssigned = null,
  currentUserId = null,
  stickyHeader = true,
}) => {
  const { t } = useTranslationApp();

  const keys = Object.keys(data);

  const filteredKeys = (
    filterByAdvertiserAssigned
      ? keys.filter((key) => {
          if (data[key]?.role !== ADVERTISER_ROLE) return false;
          const advertisersAvailable = data[key]?.advertisersAvailable;
          if (!advertisersAvailable || _.isEmpty(advertisersAvailable))
            return true;

          return advertisersAvailable.includes(filterByAdvertiserAssigned);
        })
      : keys
  ).filter((key) => {
    if (data[key]?.role === SUPER_ADMIN_ROLE && key !== currentUserId) {
      return false;
    }
    return true;
  });

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
      }}
    >
      <TableContainer
        keys={filteredKeys}
        loading={loading}
        emptyText={EMPTY_USERS}
        ariaLabel={t(USERS_TABLE_ARIA_LABEL)}
        hasPagination={false}
        stickyHeader={stickyHeader}
        minTableWidth={stickyHeader ? undefined : 0}
      >
        <TableHead>
          <TableRow>
            <TableCell isHeader={true} sx={{ pl: "16px !important" }}>
              {t(COLUMN_NAME_NAME)}
            </TableCell>
            {showEmail && (
              <TableCell isHeader={true}>{t(COLUMN_NAME_EMAIL)}</TableCell>
            )}
            {showRole && (
              <TableCell isHeader={true}>{t(COLUMN_NAME_ROLE)}</TableCell>
            )}
            {showActions && (
              <TableCell isHeader={true} resizable={false}>
                {t(COLUMN_NAME_ACTIONS)}
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredKeys.map((row, index) => {
            const user = data[row];
            if (user.isHidden) return null;
            if (user.isDeleted) return null;
            const name = user.isAnonymous ? t(ANONYMOUS_USER) : user.name;
            const email = user.isAnonymous ? "-" : user.email;

            const isLastRow = index === filteredKeys.length - 1;
            return (
              <TableRow key={index}>
                <TableCell
                  sx={{ pl: "16px !important" }}
                  indexRow={index}
                  isLastRow={isLastRow}
                >
                  {name}
                </TableCell>
                {showEmail && (
                  <TableCell indexRow={index} isLastRow={isLastRow}>
                    {email}
                  </TableCell>
                )}
                {showRole && (
                  <TableCell indexRow={index} isLastRow={isLastRow}>
                    {t(user.role)}
                  </TableCell>
                )}
                {showActions && (
                  <TableCell indexRow={index} isLastRow={isLastRow}>
                    <ActionsUser userID={row} />
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </TableContainer>
    </Box>
  );
};

export default UsersTable;
